<template>
  <div id="table" class="pompe-table">
    <slot name="filter-box"></slot>

    <div class="responsive">
      <table class="table table-sm table-bordered table-striped mt-1">
        <thead>
          <tr>
            <th v-if="checkableRows" width="20">
              <b-form-checkbox
                v-if="checkAllAvailable"
                id="checkbox-all"
                name="checkbox-1"
                :checked="isCheckedAll"
                :indeterminate="isIndeterminate"
                class="checkbox-table"
                @change="(val) => $emit('action:check-all', val)"
              />
            </th>
            <th v-if="showNumber">No</th>
            <th
              v-for="(column, idx) in columns"
              :key="column.key + '-' + idx"
              :width="column.width"
              class="px-2 py-2"
            >
              {{ column.label }}
            </th>
          </tr>
        </thead>
        <tbody v-if="isLoading">
          <tr>
            <td
              class="p-2 text-center"
              :colspan="checkableRows ? columns.length + 1 : columns.length"
            >
              <span
                class="spinner-border my-2 me-3"
                style="width: 2.5rem; height: 2.5rem"
                role="status"
              >
              </span>
            </td>
          </tr>
        </tbody>
        <tbody v-if="!isLoading && !localData.length">
          <tr>
            <td :colspan="checkableRows ? columns.length + 1 : columns.length">
              <slot name="empty"> No data </slot>
            </td>
          </tr>
        </tbody>
        <tbody v-if="!isLoading && localData?.length">
          <tr v-for="(value, idx) in localData" :key="'column-' + idx">
            <td v-if="checkableRows">
              <input
                v-if="value.showCheck"
                :id="`checkbox-${idx}`"
                :name="`checkbox-${idx}`"
                class="form-check-input mt-2 ms-0 checkbox-table"
                type="checkbox"
                :value="value.checked"
                aria-label="Checkbox for following text input"
                @change="$emit('action:check-single', idx)"
              />
            </td>
            <td v-if="showNumber">{{ idx + 1 }}</td>
            <td v-for="column in columns" :key="column.key" class="px-2 py-2">
              <div v-if="column.key !== 'action'">
                <slot :name="`#cell(${column.key})`" :row="value">
                  <span v-if="!column.format">
                    {{ value[column.key] }}
                  </span>
                  <span v-else>
                    {{ column.format(value[column.key]) }}
                  </span>
                </slot>
              </div>

              <span v-if="column.key === 'actions'">
                <slot name="action" :row="value">
                  <a
                    v-for="action in column.actions"
                    :key="action.label"
                    href="javascript:void(0)"
                    class="anchor-link"
                    @click.prevent="action.execute(value)"
                  >
                    {{ action.label }}
                  </a>
                </slot>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pompe-pagination mt-2">
      <slot name="pompe-table-pagination"></slot>
    </div>
  </div>
</template>

<script>
import ActionTable from "@/components/reusable/ActionTable/index.vue";

export default {
  name: "PompeTable",
  components: { ActionTable },
  props: {
    showPagination: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
    showNumber: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    paginationAlignment: {
      type: String,
      default: "right",
    },
    checkableRows: {
      type: Boolean,
      default: false,
    },
    checkAllAvailable: {
      type: Boolean,
      default: false,
    },
    isResponsive: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    tableHeight: {
      type: String,
      default: "100%",
    },
  },
  computed: {
    isIndeterminate() {
      const checks = this.localData.map((value) => value.checked);

      const totalData = checks.length;
      const totalSelectedData = checks.filter(Boolean).length;

      if (totalSelectedData === 0) {
        return false;
      }

      if (totalSelectedData < totalData) {
        return true;
      }

      return false;
    },
    isCheckedAll() {
      const checks = this.localData.map((value) => value.checked);

      const totalData = checks.length;
      const totalSelectedData = checks.filter(Boolean).length;

      if (totalSelectedData === totalData && totalData !== 0) {
        return true;
      }

      return false;
    },
  },
  watch: {
    pagination: {
      handler(val) {
        this.localPagination = {
          perPage: val.pageSize,
          currentPage: Number(val.pageNumber) + 1,
          totalRows: val.totalRows,
        };
      },
      deep: true,
      immediate: true,
    },
    data: {
      handler(val) {
        this.localData = [...val];
      },
      deep: true,
      immediate: true,
    },
    selectedAll: {
      handler(val) {
        this.localSelectedAll = val;
      },
      immediate: true,
    },
  },
  data: () => ({
    localPagination: {},
    localData: [],
    localSelectedAll: false,
  }),
};
</script>

<style lang="scss" scoped>
@import "@/style/color.scss";

.btn {
  padding: 0.3em 0.3em 0.3em 0.5em !important;
}
.checkbox-table {
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  margin-left: 5px;
}

.pompe-table {
  .responsive {
	  max-height: 900px;
    overflow-y: auto;
  }

  table {
    font-size: 14px;

    thead {
      th {
        font-weight: bold;
        background-color: $primary-ui;
        color: white;
      }
    }
  }
}
</style>
